import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  TypographyTitle,
  TypographyParagraph,
  TypographyText,
} from 'ant-design-vue';

interface Props {
  type?: 'title' | 'text' | 'para';
  level?: 1 | 2 | 3 | 4 | 5;
  strong?: boolean;
  ellipsis?: boolean;
  content?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RexTypographyV3',
  props: {
    type: { default: 'title' },
    level: { default: 3 },
    strong: { type: Boolean, default: false },
    ellipsis: { type: Boolean, default: false },
    content: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const TypoComp =
  props.type === 'title'
    ? TypographyTitle
    : props.type === 'para'
      ? TypographyParagraph
      : TypographyText;

const getEllipsis = props.ellipsis && { tooltip: props.content };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TypoComp), {
    level: props.level,
    strong: props.strong,
    ellipsis: _unref(getEllipsis),
    content: _ctx.content
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["level", "strong", "ellipsis", "content"]))
}
}

})